// ui/CardBoundary — per-card error boundary (Design Standard v1 done bar). One card
// throwing must never blank the page: it degrades to a plain sentence with a retry,
// while every other card keeps working. ui/Card and GlassPanel (WidgetPanel) wrap
// their children in it, so every card built on them gets one for free.
import React from 'react';

export default class CardBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[CardBoundary] ${this.props.name || 'card'} failed to render:`, error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="ds-empty" style={{ padding: 'var(--s-4)' }}>
        <p className="ds-empty__body">This section couldn’t load. Try again — if it keeps happening, reload the page.</p>
        <button type="button" className="ds-btn ds-btn--secondary ds-btn--sm" onClick={() => this.setState({ failed: false })}>
          Try again
        </button>
      </div>
    );
  }
}
